import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import "./App.css"; // Make sure CSS import hai

function App() {
  return (
    <BrowserRouter>
      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/919773112128"
        className="whatsapp-fixed-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img 
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
          alt="Chat on WhatsApp" 
        />
      </a>

      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;